import { render, staticRenderFns } from "./subModelCreate.vue?vue&type=template&id=3946a016&scoped=true&"
import script from "./subModelCreate.vue?vue&type=script&lang=js&"
export * from "./subModelCreate.vue?vue&type=script&lang=js&"
import style0 from "./subModelCreate.vue?vue&type=style&index=0&id=3946a016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946a016",
  null
  
)

export default component.exports